<template>
  <section
    class="freight-section"
    :class="{
      'freight-section--open': open,
      'freight-section--locked': locked,
    }"
  >
    <header class="freight-section__header" @click="onHeaderClick">
      <div class="freight-section__badge">{{ index }}</div>

      <div class="freight-section__heading">
        <h3 class="freight-section__title">{{ title }}</h3>
        <p v-if="subtitle" class="freight-section__subtitle">{{ subtitle }}</p>
      </div>

      <div class="freight-section__status">
        <span v-if="done" class="freight-section__done">
          <a-icon type="check-circle" theme="filled" /> Concluído
        </span>
        <a-icon v-if="locked" class="freight-section__lock" type="lock" />
        <a-icon
          v-else
          class="freight-section__chevron"
          :type="open ? 'up' : 'down'"
        />
      </div>
    </header>

    <div v-show="open && !locked" class="freight-section__body">
      <slot />
    </div>
  </section>
</template>

<script>
// Seção reutilizável do accordion de criação (Identificação / Fornecedor /
// Configurações e Rotas). Controlada pelo pai: recebe `open`/`done`/`locked`.
// - Destravada: o clique no header emite `toggle` (abre/fecha).
// - Travada (`locked`): o corpo nunca abre e o clique emite `locked-click`,
//   para o pai avisar que a etapa anterior precisa ser concluída.
export default {
  name: "FreightTableFormSection",
  props: {
    index: { type: [Number, String], required: true },
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    open: { type: Boolean, default: false },
    done: { type: Boolean, default: false },
    locked: { type: Boolean, default: false },
  },
  methods: {
    onHeaderClick() {
      if (this.locked) {
        this.$emit("locked-click");
        return;
      }
      this.$emit("toggle");
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.freight-section {
  border-bottom: 1px solid #f0f0f0;
  padding: 24px 0;

  &__header {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    cursor: pointer;
  }

  &__badge {
    // Steps Item / Progress Icon (Figma): 24px, radius 32, #234E79
    flex: 0 0 24px;
    width: 24px;
    height: 24px;
    border-radius: 32px;
    background: @color-primary;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  // Etapa travada: header apagado e cadeado no lugar do chevron. Continua
  // clicável (o clique dispara o aviso), por isso o cursor segue pointer.
  &--locked {
    .freight-section__badge {
      background: rgba(0, 0, 0, 0.25);
    }

    .freight-section__title,
    .freight-section__subtitle {
      color: rgba(0, 0, 0, 0.35);
    }
  }

  &__lock {
    color: rgba(0, 0, 0, 0.35);
  }

  &__heading {
    flex: 1 1 auto;
    min-width: 0;
  }

  &__title {
    // font-family explícita: o tema global força Montserrat em h1..h6
    font-family: @font-primary;
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.88);
    margin: 0;
  }

  &__subtitle {
    font-family: @font-primary;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.45);
    margin: 4px 0 0;
  }

  &__status {
    display: flex;
    align-items: center;
    gap: 16px;
    color: rgba(0, 0, 0, 0.45);
  }

  &__done {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: @color-success;
    font-weight: 500;
  }

  &__body {
    margin-top: 16px;
    padding: 12px 24px;
    background: rgba(0, 0, 0, 0.02);
    border-radius: 8px;
  }
}
</style>
